// Shared category taxonomy for the storefront + admin
export const CATEGORIES = [
  { key: "bone", label: "Bone Health", tagline: "Density & fracture repair" },
  { key: "muscle", label: "Muscle Recovery", tagline: "Repair & lean strength" },
  { key: "joint", label: "Joint Health", tagline: "Mobility & cartilage" },
  { key: "nerve", label: "Nerve Health", tagline: "Peripheral nerve support" },
  { key: "sports", label: "Sports Recovery", tagline: "Performance & endurance" },
  { key: "geriatric", label: "Geriatric Mobility", tagline: "Ageing & independence" },
  { key: "postsurgery", label: "Post-Surgery Recovery", tagline: "Healing & tissue repair" },
  { key: "wellness", label: "Daily Wellness", tagline: "Everyday foundations" },
];

export const CAT_LABEL = CATEGORIES.reduce((acc, c) => {
  acc[c.key] = c.label;
  return acc;
}, {});
